module.exports = __webpack_public_path__ + "media/Invoices.23e5a155.mp4";